"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UICoreDrillDown = void 0;
class UICoreDrillDown {
    generateDrillDown() {
        this.menuItems = document.querySelectorAll('.drilldown>ul>li');
        this.backButton = null !== document.querySelector('[data-drilldown]') ? document.querySelector('[data-drilldown]').getAttribute('data-back-button') : '<button>Back</button>';
        for (let i = 0; i < this.menuItems.length; i++) {
            if (this.menuItems[i].getElementsByTagName('ul').length > 0) {
                //Add back button in nested menu
                let backLi = document.createElement('li');
                backLi.innerHTML = this.backButton;
                this.menuItems[i].querySelector('ul').insertBefore(backLi, this.menuItems[i].querySelector('ul').children[0]);
                this.menuItems[i].getElementsByTagName('ul')[0].classList.add('invisible');
                this.menuItems[i].classList.add('is-drilldown-submenu-parent');
            }
        }
        this._handleEvents();
    }
    _handleEvents() {
        document.addEventListener('click', e => {
            const clickElement = e.target;
            const parentNode = clickElement.parentNode;
            if (parentNode) {
                if (parentNode.classList.contains('is-drilldown-submenu-parent')) {
                    e.stopPropagation();
                    e.preventDefault();
                    parentNode.getElementsByTagName('ul')[0].classList.remove('invisible');
                    const animationTimeout = setTimeout(() => {
                        parentNode.getElementsByTagName('ul')[0].classList.add('is-active');
                        clearTimeout(animationTimeout);
                    }, 10);
                }
                if (parentNode.classList.contains('js-drilldown-back')) {
                    parentNode.closest('ul').classList.remove('is-active');
                    const animationTimeout = setTimeout(() => {
                        parentNode.closest('ul').classList.add('invisible');
                        clearTimeout(animationTimeout);
                    }, 150);
                }
            }
        });
    }
}
exports.UICoreDrillDown = UICoreDrillDown;
